import { useFormsContext } from 'pages/forms/context/FormsProvider';
import { useMemo } from 'react';
import React from 'react';

interface IProps {
  rowIndex: number;
}
export const SupplierCounter = ({ rowIndex }: IProps) => {
  const { data } = useFormsContext();

  const counter = useMemo(() => {
    const rowData = data[rowIndex];

    return `${rowData?.totalAnsewered}/${rowData?.totalSuppliers}`;
  }, [data]);
  return <p>{counter}</p>;
};
